import { customizeHref, UrlScheme } from "~/shared/anchor";
import { DASH, SPACE } from "~/shared/str";

const COMPANY_INFO = {
  name: "Hegi Umzüge",
  address: "Tösstalstrasse 101, 8400 Winterthur",
  email: "info@hegiumzuege.com",
  phone: "+41 79 965 94 82",
  workSchedule: "07:00-18:00",
};

const COMPANY_INFO_CONTACT_LINKS = {
  email: customizeHref(UrlScheme.EMAIL, COMPANY_INFO.email),
  phone: customizeHref(UrlScheme.PHONE, COMPANY_INFO.phone.replaceAll(SPACE, DASH)),
};

export { COMPANY_INFO, COMPANY_INFO_CONTACT_LINKS };
